module.exports = __webpack_public_path__ + "static/img/axial-base-colorbar.70c0511.png";